import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userToken");

    config.headers = config.headers || {};
    config.headers["Content-Type"] = "application/json";

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      window.dispatchEvent(
        new CustomEvent("ems-session-expired", {
          detail: {
            message: "Tu sesión expiró por seguridad. Vuelve a iniciar sesión para continuar."
          }
        })
      );
    }

    return Promise.reject(error);
  }
);

export default axios;